import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";

import Modal from "react-responsive-modal";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import { Link, Redirect } from "react-router-dom";

// koneksi
import API_URL, { Post, Get, Delete } from "../function/Koneksi";

// Preview Surat
import Iframe from 'react-iframe'

// css files
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ModalBlangkoNikah from "./modal/blangko-nikah";

// const frmSurat = {
//   uuid: '',
// 		id_jenis: '',
// 		nik_pelapor: '',
// 		nik: '',
// 		kk:'',
// 		nama_pemohon: '',
// 		tempat_lahir: '',
// 		tanggal_lahir: '',
// 		jenis_kelamin: '',
// 		status_perkawinan: '',
// 		pekerjaan: '',
// 		agama: '',
// 		alamat: '',
// 		pendidikan_terakhir: '',
// 		kewarganegaraan: '',
// 		tujuan_pembuatan: '',
// 		detail_surat: {
//       status_perkawinan_lk: '',
// 			status_perkawinan_pr: '',
// 			data_ayah: {
// 				nama_ayah_pemohon: '',
// 				bin_binti_ayah: '',
// 				nik_ayah: '',
// 				tempat_lahir_ayah: '',
// 				tanggal_lahir_ayah: '',
// 				kewarganegaraan_ayah: '',
// 				agama_ayah: '',
// 				pekerjaan_ayah: '',
// 				alamat_ayah: '',
// 			},
// 			data_ibu: {
// 				nama_ibu_pemohon: '',
// 				bin_binti_ibu: '',
// 				nik_ibu: '',
// 				tempat_lahir_ibu: '',
// 				tanggal_lahir_ibu: '',
// 				kewarganegaraan_ibu: '',
// 				agama_ibu: '',
// 				pekerjaan_ibu: '',
// 				alamat_ibu: '',
// 			},
// 			data_pasangan: {
// 				nama_pasangan: '',
// 				bin_binti_pasangan: '',
// 				nik_pasangan: '',
// 				tempat_lahir_pasangan: '',
// 				tanggal_lahir_pasangan: '',
// 				kewarganegaraan_pasangan: '',
// 				agama_pasangan: '',
// 				pekerjaan_pasangan: '',
// 				alamat_pasangan: '',
// 			},
// 			data_ex_pasangan: {
// 				nama_ex_pasangan: '',
// 				bin_binti_ex_pasangan: '',
// 				nik_ex_pasangan: '',
// 				tempat_lahir_ex_pasangan: '',
// 				tanggal_lahir_ex_pasangan: '',
// 				kewarganegaraan_ex_pasangan: '',
// 				agama_ex_pasangan: '',
// 				pekerjaan_ex_pasangan: '',
// 				alamat_ex_pasangan: '',
// 				tempat_ex_meninggal: '',
// 				tanggal_ex_meninggal: '',
// 				status_hubungan: ''
// 			},
// 			data_pernikahan: {
// 				tanggal_pernikahan: '',
// 				jam_pernikahan: '',
// 				lokasi_pernikahan: '',
// 				lampiran: []
// 			},
// 		},
// }

class BasicTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: [],
      status: {
        form: false,
        btnForm: false,
        btnAksi: [],
        dataPenduduk: "none",
        dataPenduduk2: "none",
        frmPreviewDraft: false,
        jenis_form: '',
        nikMantan: "none",
        jenis_kelamin_pelapor: null,
      },
      awal: "",
      sebelum: "",
      hal: [],
      setelah: "",
      akhir: "",
      dt: null,
      frmStatusPerkawinan: [],
      frmStatusPerkawinanLk: [],
      frmStatusPerkawinanPr: [],
      loading: false,
      loadingPreview: false,
      tmplistPenduduk: null,
      judul: "Tambah Surat Blangko Nikah",
      shdk: "",
      // ============ Select 2 ==============
      frmNik: [],
      nikStat: null,
      // frmNik2: [],
      // nik2Stat: null,
      // ===================================
      // ============ Alert ==============
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",
      successAlert: false,
      // ===================================
      // ============ Tanggal ==============
      // ===================================
      // =============== acc ===============
      formAcc: false,
      formSelectAcc: [
        { value: "Disetujui", label: "Disetujui" },
        { value: "Ditolak", label: "Ditolak" }
      ],
      frmTTD: [],
      accButton: [],
      accuuid: "",
      btnFormAcc: true,
      tableAcc: "none",
      //dispopsisi

      datDisposisi: [],
      riwayatDisposisi: [],
      
      // Preview surat
			get_data_surat:[],
			get_jenis_surat: "",
      
      // Cari Data
      dataCari: {
				q: '',
			},
    };
  }
  
  // ================== Sweet Alert ==================
  closeAlert = () => {
    this.setState({
      show: false,
      successAlert: false
    });
  };

  onRecieveInput = value => {
    this.setState({
      alert: (
        <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
          You wrote: {value}
        </SweetAlert>
      )
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

// ################################################################################################

  // FETCH DATA SURAT
  fetch = (params = {}) => {
    this.setState({ loading: true })
    let link = "";
    if (params.page) {
      switch (params.page) {
        case ">>":
          link =
            "?page=" +
            Math.ceil(
              this.state.pagination.total / this.state.pagination.per_page
            );
          break;
        case ">":
          link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
          break;
        case "<":
          link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
          break;
        case "<<":
          link = "?page=1";
          break;
        default:
          link = "?page=" + params.page;
          break;
      }
    }

    Post(
      "surat-keterangan/grup/" + this.props.location.state.uuid + link,
      null, this.state.dataCari,
      dtkat => {
        if(dtkat.data.results){
          this.setState({ data: dtkat.data.results.data, pagination: dtkat.data.results, loading: false });
          this.pagination(dtkat.data.results); 
          
          // For testing
          if (this.props.getListBlangkoNikah) {
            this.props.getListBlangkoNikah(dtkat.data.results.data)
          }
        }
      }
    );
  };

  // PAGINATION SURAT
  pagination = data => {
    let awal = "";
    let hal = [];
    let sebelum = "";
    let setelah = "";
    let akhir = "";
    if (data.total > 0) {
      let start = 1;
      let end = 5;
      let n = 0;
      let p = 0;
      if (data.current_page <= 3) {
        start = 1;
        end = 5;
        if (data.last_page > data.current_page) {
          n = data.current_page + 1;
        }
      } else {
        p = data.current_page - 1;
        n = data.current_page + 1;
        start = data.current_page - 2;
        end = data.current_page + 2;
      }
      if (end >= data.last_page - 2) {
        p = data.current_page - 1;
        if (start >= 5) {
          start = data.last_page - 4;
        }
        end = data.last_page;
      }

      for (let i = start; i <= end; i++) {
        let warna = "primary-custom";
        if (i === data.current_page) {
          warna = "danger";
        }
        hal.push(
          <a
            href={() => false}
            onClick={() => this.fetch({ page: i })}
            className={
              "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            }
          >
            {i}
          </a>
        );
      }
      if (p > 0) {
        sebelum = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: p })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<"}
          </a>
        );
      }
      if (n > 0) {
        setelah = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: n })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">"}
          </a>
        );
      }
      awal = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: 1 })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {"<<"}
        </a>
      );
      akhir = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: data.last_page })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {">>"}
        </a>
      );
    }
    this.setState({ awal, sebelum, hal, setelah, akhir });
  };

  // TOMBOL AKSI SURAT
  tombolAksi = (cell, row) => {
    let btnAksi = false;
    let status = "";
    row.data_status.forEach(dt => {
      status = dt.status;
    });
    if (status === "Diajukan") {
      // btnCetak = true;
      btnAksi = true;
      // btnApproval = true;
    } else {
      btnAksi = true;
      // btnApproval = true;
      if (status === "Ditolak") {
        // btnCetak = true;
      } else if (status === "Disetujui") {
        btnAksi = false;
        // btnCetak = true;
        // btnApproval = false;
      } else if ((status === "Menunggu Penerbitan") | (status === "Selesai")) {
        // btnAksi = false;
        // btnCetak = false;
        // btnApproval = false;
      } else {
        // btnCetak = true;
      }
    }
    return (
      <>
        {/* <Button
          size="xs"
          color="info"
          className="btn-icon"
          onClick={() => this.konfirmApprove(row.uuid)}
          disabled={btnApproval}
        >
          <i className="fa fa-check"></i>
        </Button>{" "}
        &nbsp;&nbsp; */}
        <Button
          size="xs"
          color="success"
          className="btn-icon"
          onClick={() => this.ubahData(row.uuid)}
          disabled={btnAksi}
        >
          <i className="fa fa-pencil"></i>
        </Button>{" "}
        &nbsp;&nbsp;
        {/* <Button
          size="xs"
          color="danger"
          className="btn-icon"
          onClick={() => this.konfirmHapus(row.uuid)}
          disabled={btnAksi}
        >
          <i className="fa fa-trash"></i>
        </Button>{" "} */}
        {/* 
        &nbsp;&nbsp;
        <Button
          size="xs"
          color="info"
          className="btn-icon"
          onClick={e => this.cetakSurat(e, row)}
          disabled={btnCetak}
        >
          <i className="fa fa-print"></i>
        </Button>
        &nbsp;&nbsp; */}
        {/* //list */}
        {/* <Button
          size="xs"
          color="info"
          className="btn-icon"
          onClick={e => this.listDisposisi(row)}
        >
          <i className="fa fa-list"></i>
        </Button> */}
      </>
    );
  };
  
  // TAMBAH DATA SURAT
  tambahData = e => {
    this.setState({
      status: {
        ...this.state.status,
        form: true,
        dataPenduduk: "none",
        dataPenduduk2: "none",
        nikMantan: "none",
        jenis_kelamin_pelapor: null,
      },
      dt: null,
      nikStat: null,
      nik2Stat: null,
    });
  };

  // UBAH DATA SURAT
  ubahData = id => {
    this.setState({ loadingPreview: true })
    Get("surat-keterangan/grup/find", id, data => {
      //json parse
      console.log('ubahdata')
      console.log(data.results)
      let detail_surat = JSON.parse(data.results.detail_surat)
      console.log(detail_surat)

      if (id && data.results.kk !== '') {

        let nikMantan = "none"
        
        let nik_ex_pasangan= ''
        let nama_ex_pasangan= ''
        let bin_binti_ex_pasangan= ''
        let tempat_lahir_ex_pasangan= ''
        let tanggal_lahir_ex_pasangan= null
        let agama_ex_pasangan= ''
        let pekerjaan_ex_pasangan= ''
        let alamat_ex_pasangan= ''
        let tempat_ex_meninggal= ''
        let tanggal_ex_meninggal= null
        let status_hubungan= ''
        
        if(data.results.status_perkawinan === "Cerai mati"){
          nikMantan = "block"

          nik_ex_pasangan = detail_surat.data_ex_pasangan.nik_ex_pasangan
          nama_ex_pasangan = detail_surat.data_ex_pasangan.nama_ex_pasangan
          bin_binti_ex_pasangan = detail_surat.data_ex_pasangan.bin_binti_ex_pasangan
          tempat_lahir_ex_pasangan = detail_surat.data_ex_pasangan.tempat_lahir_ex_pasangan
          tanggal_lahir_ex_pasangan = new Date (detail_surat.data_ex_pasangan.tanggal_lahir_ex_pasangan)
          agama_ex_pasangan = detail_surat.data_ex_pasangan.agama_ex_pasangan
          pekerjaan_ex_pasangan = detail_surat.data_ex_pasangan.pekerjaan_ex_pasangan
          alamat_ex_pasangan = detail_surat.data_ex_pasangan.alamat_ex_pasangan
          tempat_ex_meninggal = detail_surat.data_ex_pasangan.tempat_ex_meninggal
          tanggal_ex_meninggal = detail_surat.data_ex_pasangan.tanggal_ex_meninggal ? new Date (detail_surat.data_ex_pasangan.tanggal_ex_meninggal) : ''
          status_hubungan = detail_surat.data_ex_pasangan.status_hubungan
        }

        let jenisKelamin = null;
        if (data.results.jenis_kelamin === 'Perempuan') {
          jenisKelamin = 'P';
        } else {
          jenisKelamin = 'L';
        }

        this.setState({
          dt: {
            // ...this.state.dt,
            uuid: data.results.uuid,
            id_jenis: data.results.id_jenis,
            nik: data.results.nik,
            kk: data.results.kk,
            nama_pemohon: data.results.nama_pemohon,
            tempat_lahir: data.results.tempat_lahir,
            tanggal_lahir: data.results.tanggal_lahir,
            jenis_kelamin: data.results.jenis_kelamin,
            pendidikan_terakhir: data.results.pendidikan_terakhir,
            kewarganegaraan: data.results.kewarganegaraan,
            pekerjaan: data.results.pekerjaan,
            agama: data.results.agama,
            alamat: data.results.alamat,
            alamat_kk: data.results.alamat_kk,
            tujuan_pembuatan: data.results.tujuan_pembuatan,
            status_perkawinan: {
              value: data.results.status_perkawinan,
              label: data.results.status_perkawinan
            },
            // Data Ayah
            nik_ayah:detail_surat.data_ayah.nik_ayah,
            nama_ayah:detail_surat.data_ayah.nama_ayah_pemohon,
            bin_binti_ayah:detail_surat.data_ayah.bin_binti_ayah,
            tempat_lahir_ayah:detail_surat.data_ayah.tempat_lahir_ayah,
            tanggal_lahir_ayah: detail_surat.data_ayah.tanggal_lahir_ayah ? new Date (detail_surat.data_ayah.tanggal_lahir_ayah) : '',
            kewarganegaraan_ayah:detail_surat.data_ayah.kewarganegaraan_ayah,
            agama_ayah:detail_surat.data_ayah.agama_ayah,
            pekerjaan_ayah:detail_surat.data_ayah.pekerjaan_ayah,
            alamat_ayah:detail_surat.data_ayah.alamat_ayah,
            // Data Ibu
            nik_ibu:detail_surat.data_ibu.nik_ibu,
            nama_ibu:detail_surat.data_ibu.nama_ibu_pemohon,
            bin_binti_ibu:detail_surat.data_ibu.bin_binti_ibu,
            tempat_lahir_ibu: detail_surat.data_ibu.tempat_lahir_ibu,
            tanggal_lahir_ibu: detail_surat.data_ibu.tanggal_lahir_ibu ? new Date (detail_surat.data_ibu.tanggal_lahir_ibu) : '',
            kewarganegaraan_ibu:detail_surat.data_ibu.kewarganegaraan_ibu,
            agama_ibu:detail_surat.data_ibu.agama_ibu,
            pekerjaan_ibu:detail_surat.data_ibu.pekerjaan_ibu,
            alamat_ibu:detail_surat.data_ibu.alamat_ibu,
            // Data Pasangan
            nama_pasangan:detail_surat.data_pasangan.nama_pasangan,
            bin_binti_pasangan:detail_surat.data_pasangan.bin_binti_pasangan,
            nik_pasangan:detail_surat.data_pasangan.nik_pasangan,
            tempat_lahir_pasangan:detail_surat.data_pasangan.tempat_lahir_pasangan,
            tanggal_lahir_pasangan:new Date (detail_surat.data_pasangan.tanggal_lahir_pasangan),
            kewarganegaraan_pasangan:detail_surat.data_pasangan.kewarganegaraan_pasangan,
            agama_pasangan:detail_surat.data_pasangan.agama_pasangan,
            pekerjaan_pasangan:detail_surat.data_pasangan.pekerjaan_pasangan,
            alamat_pasangan:detail_surat.data_pasangan.alamat_pasangan,
            // Data Pasangan Sebelumnya
            nik_ex_pasangan,
            nama_ex_pasangan,
            bin_binti_ex_pasangan,
            tempat_lahir_ex_pasangan,
            tanggal_lahir_ex_pasangan,
            agama_ex_pasangan,
            pekerjaan_ex_pasangan,
            alamat_ex_pasangan,
            tempat_ex_meninggal,
            tanggal_ex_meninggal,
            status_hubungan,
            // Data Pernikahan
            tanggal_pernikahan: new Date (detail_surat.data_pernikahan.tanggal_pernikahan),
            jam_pernikahan: new Date (detail_surat.data_pernikahan.jam_pernikahan),
            lokasi_pernikahan:detail_surat.data_pernikahan.lokasi_pernikahan,
            waktu_pernikahan: new Date (detail_surat.data_pernikahan.waktu_pernikahan),
            lampiran:detail_surat.data_pernikahan.lampiran,
            // Data Lainnya
            status_perkawinan_lk: detail_surat.status_perkawinan_lk,
            status_perkawinan_pr: detail_surat.status_perkawinan_pr,
            status_perkawinan_lk_lainnya: detail_surat.status_perkawinan_lk_lainnya,
          },
          status: {
            ...this.state.status,
            form: true,
            dataPenduduk: "block",
            nikMantan: nikMantan,
            jenis_kelamin_pelapor: jenisKelamin,
          },
          nikStat: {
            value: data.results.nik,
            label: data.results.nik + ' (' + data.results.nama_pemohon + ')'
          },
          loadingPreview: false
        })

      }
      else{
        this.setState({
          loadingPreview: false,
        })
      }

    })
  };

  // HAPUS DATA SURAT
  konfirmHapus = id => {
    this.setState({
      alert: (
        <SweetAlert
          showCancel
          confirmBtnText="Hapus"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="success"
          type="danger"
          title="Yakin ingin hapus data ?"
          onCancel={this.hideAlert}
          onConfirm={() => this.hapusData(id)}
        >
          Proses ini tidak dapat dibatalkan!
        </SweetAlert>
      )
    });
  };

  hapusData = id => {
    this.hideAlert();
    let psn = "Hapus";
    Delete("surat-keterangan/grup/delete", id, res => {
      if (res === 200) {
        this.setState({
          show: true,
          basicType: "success",
          basicTitle: "Data Surat Pindah Desa BPN",
          pesanAlert: "Berhasil " + psn + " Data"
        });
      } else {
        this.setState({
          show: true,
          basicType: "danger",
          basicTitle: "Data Surat Pindah Desa BPN",
          pesanAlert: "Gagal " + psn + " Data"
        });
      }
      this.componentDidMount();
    });
  };

  // CARI DATA SURAT
  cariData = e => {
    if (e.key === 'Enter') {
      this.setState({ 
        dataCari:{
          ...this.state.dataCari,
          q: e.target.value,
        }, 
      });

      setTimeout(
        function() {
          this.fetch({ page: null, where: [] });
        }.bind(this),
        500
      );
    }
  };

// ################################################################################################

  componentDidMount() {
    if (this.props.location.state) {
      this.fetch({ page: null, where: [] });
      
      let set_jenis = this.props.location.state.route_surat.substring(1);
      this.setState({
        get_jenis_surat: set_jenis,
      })

      Get("penduduk", null, data => {
        let frmNik = [];
        let tmplistPenduduk = {}
        data.results.data.forEach(dt => {
          frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
          tmplistPenduduk = {
            ...tmplistPenduduk,
            [dt.id]: dt
          }
        });
        this.setState({ frmNik, tmplistPenduduk });

        // For testing
        if (this.props.getListNIK) {
          this.props.getListNIK(frmNik)
        }
      });
      Get("select-enum/penduduk/status_perkawinan", null, data => {
        let frmStatusPerkawinan = [];
        data.forEach(dt => {
          frmStatusPerkawinan.push({ value: dt, label: dt });
        });
        this.setState({ frmStatusPerkawinan });
      });
      this.setState({
        frmStatusPerkawinanLk: [
          { value: "Jejaka", label: "Jejaka" },
          { value: "Duda", label: "Duda" },
          { value: "", label: "Lainnya" },
        ],
        frmStatusPerkawinanPr: [
          { value: "Perawan", label: "Perawan" },
          { value: "Janda", label: "Janda" },
        ],
      })
    } else {
      this.setState({ redirect: true });
    }
  }

  // cek redirect jika state kosong
  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
  };

  render() {

    var data = this.state.data;
    
    let no = 0;

    // const { SearchBar } = Search;
    const columns = [
      {
          dataField: "no",
          text: "No",
          isDummyField: true,
          csvExport: false,
          headerAlign: 'center',
				  align: 'center',
          formatter: (key, obj, index) =>{          
              let current_pagenum = this.state.pagination.current_page;
              let total_records_per_page = this.state.pagination.per_page;
              let row_index = (index+1);
              let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
              return serial_num; 
          }
      },
      {
        dataField: "tanggal_surat",
        headerAlign: 'center',
				align: 'center',
        text: "Tanggal",
        formatter: (cell, obj) => {
          let plainTime = '-'
					if (obj.created_at) {
						let date = new Date(obj.created_at)
						date = date.toLocaleString('id-ID')
						
						const datetime = date.split(' ')
						
	
						date = datetime[0]
						let time = datetime[1]
	
						const splitDate = date.split('/')
						time = time.replaceAll('.', ':')
	
						const list_bulan = [
							'Januari',
							'Februari',
							'Maret',
							'April',
							'Mei',
							'Juni',
							'Juli',
							'Agustus',
							'September',
							'Oktober',
							'November',
							'Desember'
						];

						plainTime = `${splitDate[0]} ${list_bulan[parseInt(splitDate[1]) - 1]} ${splitDate[2]}  ${time}`;
					}

					return plainTime
        },
        isDummyField: true,
        sort: true
      },
      {
        dataField: "kode_surat",
        headerAlign: 'center',
				align: 'center',
        text: "Kode Pengajuan",
        formatter: (cell, obj) => {
          return obj.kode_surat === "" || obj.kode_surat === null ? "-" : obj.kode_surat;
        },
        sort: true
      },
      {
        dataField: "nomor",
        headerAlign: 'center',
				align: 'center',
        text: "Nomor surat",
        formatter: (cell, obj) => {
          return obj.nomor === "" ? "-" : obj.nomor;
        },
        sort: true
      },
      {
        dataField: "nik",
        headerAlign: 'center',
				align: 'center',
        text: "NIK",
        sort: true
      },
      {
        dataField: "nama_pemohon",
        headerAlign: 'center',
				align: 'center',
        text: "Nama",
        sort: true
      },
      {
        dataField: "status",
        headerAlign: 'center',
				align: 'center',
        text: "Status",
        isDummyField: true,
        formatter: (cell, obj) => {
          let status = "-";
          obj.data_status.forEach(dt => {
            status = dt.status;
          });
          
          if(status === 'Selesai Mobile'){
            status = "Disetujui";
          }

          return status;
        },
        sort: true
      },
      {
        dataField: "aksi",
        headerAlign: 'center',
				align: 'center',
        text: "Aksi",
        isDummyField: true,
        csvExport: false,
        formatter: this.tombolAksi
      }
    ];

    // const defaultSorted = [
    //   {
    //     dataField: "nama",
    //     order: "asc"
    //   }
    // ];

    // const pageButtonRenderer = ({
    //   page,
    //   active,
    //   disable,
    //   title,
    //   onPageChange
    // }) => {
    //   const handleClick = e => {
    //     e.preventDefault();
    //     this.fetch({ where: [], page: page });
    //   };
    //   var classname = "";
    //   classname = "btn btn-primary-custom";
    //   return (
    //     <li className="page-item pl-1" key={page}>
    //       <a
    //         href="javascript:void()"
    //         onClick={handleClick}
    //         className={classname}
    //       >
    //         {page}
    //       </a>
    //     </li>
    //   );
    // };

    // const options = {
    //   alwaysShowAllBtns: true,
    //   pageButtonRenderer,
    //   // custom: true,
    //   paginationTotalRenderer: () => (
    //     <span className="react-bootstrap-table-pagination-total">
    //       Showing {from} to {to} of {total} Results
    //     </span>
    //   ),
    //   paginationSize: size,
    //   totalSize: total
    // };
    no = 0;
    const tableTTD = this.state.frmTTD.map((dt, i) => {
      no++;
      return (
        <tr key={i}>
          <td>{no}</td>
          <td>{dt.jabatan}</td>
          <td>{dt.jabatan_pengganti ? dt.jabatan_pengganti : "-"}</td>
          <td>{dt.nama}</td>
          <td>{dt.nip ? dt.nip : "-"}</td>
          <td>{dt.status ? dt.status : "-"}</td>
          <td>
            <Button
              size="xs"
              onClick={() => this.pilih(dt.uuid, i)}
              color={
                this.state.accButton.length > 0
                  ? this.state.accButton[i] === 0
                    ? "default"
                    : "danger"
                  : "danger"
              }
              className="btn-icon"
            >
              {this.state.accButton.length > 0
                ? this.state.accButton[i] === 0
                  ? "Dipilih"
                  : "Pilih"
                : "Pilih"}
            </Button>
          </td>
        </tr>
      );
    });

    return (
      <div data-testid="page-surat blangko nikah">
        {this.renderRedirect()}
        {/* <Breadcrumb title="Data Surat Blangko Nikah" parent="Admin" /> */}
        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="info"
          onCancel={this.closeAlert}
          showConfirm={false}
        >
          {this.state.pesanAlert}
          {this.state.successAlert ? (
            <div>
              <br />
              <Button
                color="success"
                onClick={() => {
                  this.closeAlert();
                  this.tambahData();
                }}
              >
                Tambah Data
              </Button>{" "}
              <Button
                // color="info"
                className="btn btn-secondary-custom"
                // onClick={() => {
                //   this.closeAlert();
                // }}
              >
                <Link
                  data-testid="btn-eksekusi_surat"
                  onClick={() => {
                    // For testing
                    if (this.props.clickEksekusiSurat) {
                      this.props.clickEksekusiSurat()
                    }
                  }}
                  to={{
                    pathname: process.env.PUBLIC_URL + "/admin/disposisi",
                    tabProps: "2"
                  }}
                >
                  <span style={{ color: "white" }}>Eksekusi Surat</span>
                </Link>
              </Button>
            </div>
          ) : (
            ""
          )}
        </SweetAlert>

        {this.state.alert}

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card mb-0">
                <div className="card-header">
                  <div className="row">
                    <div className="col-sm-6">
                      {/* <div className="row">
                        <div className="col-lg-4"> */}
                          <input
                            type="text"
                            className="form-control"
                            id="cariTable"
                            placeholder="Cari berdasarkan kode pengajuan atau nik pemohon atau nomor surat"
                            onKeyPress={this.cariData}
                          />
                        {/* </div>
                      </div> */}
                      {/* <h5>Data Surat Blangko Nikah</h5> */}
                      {/* <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span> */}
                    </div>
                    <div className="col-sm-6 text-right">
                      <Button
                        data-testid="tblCreateSuratBlangkoNikah"
                        size="sm"
                        color="success"
                        // className="btn-square"
                        onClick={() => {
                          this.tambahData()
                        }}
                      >
                        Tambah Data
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="card-body datatable-react">
									{this.state.loading ? (
										<div className="row">
											<div className="col-sm-12" align="center">
												<img
													alt="loading"
													src={require("../assets/images/tes-loading.gif")}
													style={{
														borderRadius: "10px",
														width: '100px'
													}} />
											</div>
										</div>
									) : (
										<>
                      {data.length > 0 ? (
                        <>
                          <BootstrapTable keyField="id" data={data} columns={columns} />
                          <div className="pull-right text-white">
                            {this.state.awal}
                            {this.state.sebelum}
                            {this.state.hal.map(dt => {
                              return dt;
                            })}
                            {this.state.setelah}
                            {this.state.akhir}
                          </div>
                        </>
                      ) : (
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="text-center mb-2 mt-2">Data tidak ditemukan</h6>
                          </div>
                        </div>
                      )}
                    </>
									)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        {/* Loading preview */}
        <SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>
        
				{/* Modal Preview Draft Surat */}
				<Modal
					classNames={{ overlay: 'custom-map-modal' }}
					open={this.state.status.frmPreviewDraft}
					onClose={() => {
						// this.setState({
						// 	status:{
						// 		...this.state.status,
						// 		modalKonfirmasi: true,
						// 		frmPreviewDraft: false,
						// 	}
						// })
					}}
					styles={{ 
						modal: {
							width: '100%',
							height: '100%',
							maxHeight: 'unset',
							maxWidth: 'unset',
						  }
					}}
					closeOnEsc={false}
					closeOnOverlayClick={false}
				>
					<div
						className="modal-body"
						style={{
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							height: '90%',
							alignItems: 'center'
						}}
					>
							<center>
								<span><h4><b>Berikut adalah draft surat yang telah anda ajukan,<br/> silahkan cek kelengkapan data anda sebelum melanjutkan!</b></h4></span><br/>
							</center>

							<Iframe 
								id="myFrame" 
								src={
									API_URL +
									// 'cetak-surat/' +
									this.state.get_jenis_surat +
									// '/' +
									this.state.get_data_surat.uuid_surat +
									'?show=Ya&status_preview=ya#toolbar=0'
								}
								// styles={
								// 	{display: 'none'}
								// }
								onLoad={(e) => {
									this.setState({
										loadingPreview: false
									})
								}}
								width="100%"
								height="100%"
								className="myClassname"
								display={this.state.loadingPreview ? "none" : "block"}
								position="relative"
							/>
						{/* </div> */}
					</div>
					<div
						className="modal-footer"
						style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
					>
						<button
							onClick={() => {
                this.setState({
									status:{
                    ...this.state.status,
                    frmPreviewDraft: false,
                  },
								})
								this.ubahData(this.state.get_data_surat.uuid_surat)
							}}
							className="btn btn-warning"
						>
							Ubah Data Pengajuan
						</button>
						<button
							onClick={() => {
                this.setState({
                  status:{
                    ...this.state.status,
                    frmPreviewDraft: false,
                  },
                  showBio: false,
                  show: true,
                  basicType: "success",
                  basicTitle: "Data Surat Blangko Nikah",
                  pesanAlert: "Berhasil "+ this.state.status.jenis_form +" Data",
                  successAlert: true
                });
							}}
							className="btn btn-success"
						>
							Lanjutkan Pengajuan
						</button>
					</div>
				</Modal>
				{/* End Modal Preview Draft Surat */}

        <ModalBlangkoNikah
          data={this.state.dt}
          isOpen={this.state.status.form}
          propsData={this.props}
          kiosk={false}
          optionData={{
            frmNik: this.state.frmNik,
            tmplistPenduduk: this.state.tmplistPenduduk,
            nikStat: this.state.nikStat,
            status: this.state.status,
            frmStatusPerkawinan: this.state.frmStatusPerkawinan,
            frmStatusPerkawinanLk: this.state.frmStatusPerkawinanLk,
            frmStatusPerkawinanPr: this.state.frmStatusPerkawinanPr,
          }}
          setAlert={(e) => {
            this.setState(e)
          }}
          setStatusRefresh={(e) => {
            if (e) {
              this.fetch({ page: null, where: [] });
            }
          }}
          setIsOpen={(e) => {
            if (!e) {
              this.setState({ dt: null })
            }
            this.setState({
              status: {
                ...this.state.status,
                form: e
              }
            })
          }}
        />
        
        <Modal
          open={this.state.formAcc}
          onClose={this.tutupForm}
          styles={{ modal: { width: "80%" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <Form className="theme-form" onSubmit={this.simpanAcc}>
            <div className="modal-header">
              <h5 className="modal-title">Konfirmasi Surat</h5>
            </div>
            <div className="modal-body">
              {/* <input
                className="form-control"
                id="uuid"
                type="hidden"
                placeholder=""
                defaultValue={this.state.dt.uuid}
              /> */}
              <FormGroup className="row">
                <Label
                  className="col-sm-3 col-form-label"
                  htmlFor="inputEmail3"
                >
                  Tanggal Surat
                </Label>
                <Col sm="9">
                  {/* <Datepicker
                    id="tanggal_surat"
                    todayButton={"Today"}
                    dateFormat="dd/MM/yyyy"
                    selected={this.state.tanggal_surat}
                    onChange={e => this.gantiTgl(e, "tanggal_surat")}
                    className="form-control"
                  /> */}
                </Col>
              </FormGroup>

              <Col sm="12">
                <table className="table table-bordered table-stripes table-hovered">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Jabatan</th>
                      <th>Jabatan Pengganti</th>
                      <th>Nama</th>
                      <th>NIP</th>
                      <th>Status</th>
                      <th>
                        <i className="fa fa-check"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>{tableTTD}</tbody>
                </table>
              </Col>
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary-custom">
                Selesai
              </button>
            </div>
          </Form>
        </Modal>
        <Modal
          open={this.state.formDisposisi}
          onClose={this.tutupForm}
          styles={{ modal: { width: "80%" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <Form className="theme-form">
            <div className="modal-header">
              <h5 className="modal-title">Disposisi Surat</h5>
            </div>
            <div className="modal-body">
              <table className="table table-bordered table-stripes table-hovered">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Jabatan</th>
                    <th>Level</th>
                    <th>TTD</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.datDisposisi.map((dt, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{dt.data_jabatan.nama}</td>
                        <td>{dt.level}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-info"
                            onClick={() => {
                              this.disposisi(dt.uuid, this.state.idSurat);
                            }}
                            disabled={this.state.status.btnForm}
                          >
                            Disposisi
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="modal-body">
              <table className="table table-bordered table-stripes table-hovered">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Status</th>
                    <th>Pejabat</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.riwayatDisposisi.map((dt, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>
                          {dt.status === 0
                            ? "Menunggu Disposisi"
                            : dt.status === 1
                            ? "Telah di disposisi"
                            : "Ditolak"}
                        </td>
                        <td>{dt.data_perangkat.data_jabatan.nama}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-warning"
                disabled={this.state.btnFormAcc}
                onClick={this.tutupForm}
              >
                Tutup
              </button>
              <button
                type="submit"
                className="btn btn-success"
                disabled={this.state.btnFormAcc}
              >
                Simpan
              </button>
            </div>
          </Form>
        </Modal>

      </div>
    );
  }
}

export default BasicTable;
